import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Message } from 'primeng/primeng';
import { MainService } from '../../main.service';

@Component({
  selector: 'app-select-qa',
  templateUrl: './select-qa.component.html',
  styleUrls: ['../../../style.scss', './select-qa.component.css']
})
export class SelectQAComponent implements OnInit {
  selectedEditQA: any;
  userOptions: {};
  userList: any[];
  msgs: Message[];

  constructor(
    private mainService: MainService,
    public dialogRef: MatDialogRef<SelectQAComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {

  }

  onCancel(): void {
    this.dialogRef.close();
  }

  sendQAUpdate() {
    if (this.selectedEditQA) {
      this.dialogRef.close({ data: this.data, qa: this.selectedEditQA });
    } else {
      this.msgs = [];
      this.msgs.push({ severity: 'error', summary: 'QA not selected', detail: 'Please Select a QA Engineer' });
    }
  }



  getQAUsers() {
    this.mainService.getUsers(this.userOptions).then(users => {
      this.userList = users;
    });

  }

  ngOnInit() {
    this.userOptions = {
      id: this.data.project_id,
      role: 'QA'
    };

    this.getQAUsers();
  }

}
